import React, { Component } from 'react';
import _ from 'lodash';
import moment from 'moment';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {
  Button,
  Checkbox,
  Col,
  Form,
  Icon,
  message,
  Modal,
  Pagination,
  Row,
  Select,
  Spin,
  Table
} from 'antd';
import { nanoid } from 'nanoid';
import jump from 'jump.js';

import ChangePageModal from '../../components/changePageModal/ChangePageModal';
import SightingsModal from '../../components/sightingsModal/SightingsModal';
import {
  FILTER_OPTIONS,
  getQcImageStatuses,
  SIGHTINGS_COLUMNS
} from '../finalReviewPage/FinalReviewPageConstants';

import {
  getDomainData,
  getLanguages,
  getImageData
} from '../../redux/action/common/CommonActions';
import {
  changeDeliveredData,
  changeDomainDataInRedux,
  changeDomainReviewImagesData,
  clearDeliveredData,
  clearDomainReviewImagesData,
  getDomainsDeliveredIDs,
  getDomainsImagesStatusesIds,
  getDownloadedImagesData,
  getFirstDomainSightings,
  getLastDomainSightings,
  getReserveDomainPending,
  getReserveDomainPendingForReview,
  saveDomainDataAsReview,
  setReturnedForCommentTrue,
  setReturnedForReview,
  updateDomainHoldData,
  updateImagesData,
  updateImagesHoldData,
  updateImageStatus,
  sendUpdatedImageURL,
  filterSightings,
  getFacebookImageUrl
} from '../../redux/action/qc_fr/QC_FRActions';
import {
  removeFromBlackList,
  setDomainToBlackList
} from '../../redux/action/blackList/blackListActions';
import {
  sendReportForImages,
  setDeliveredStatus,
  setDownLoadFileRequest
} from '../../redux/action/exportActions/exportActions';
import { setBulkChanges } from '../../redux/action/finalReviewPage/finalReviewPage';
import { discardQC } from '../../redux/action/chat/ChatActions';
import {
  saveCurrentChangesForDomain,
  saveCurrentChangesForImages
} from '../../redux/action/saveChanges/saveChangesActions';
import { approveCurrentDomain } from '../../redux/action/saveChanges/saveChangesActions';

import './QualityControlPage.css';
import classNames from 'classnames';
import { getLoggedUserStatisticData } from '../../redux/action/user/UserActions';
import { PhotographerColumn } from './photographerColumn/PhotographerColumn';
import ImageAwarePopover from './imageAwarePopover/ImageAwarePopover';
import { getCountriesList } from '../../redux/action/search/SearchActions';

const { Option } = Select;

// const DOMAIN_OBJECT = {
//   img_data_989111475: {
//     imageData: {
//       id: 989111475,
//       imageId: '11333965',
//       createdAt: '2025-07-29T00:05:53.904125Z',
//       updatedAt: '2025-07-29T00:05:53.904125Z',
//       updatedBy: null,
//       status: 'PENDING',
//       imageUrl:
//         'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSAgS1MT3IghGT1pcs16cNks0esCMUlMvTHUg2zR3LQSvyoFuatANJkv4l3&s',
//       downloaded: false,
//       usageUrl: 'https://pedicurepodologuesete.com/informations-et-conseils',
//       originalImageFileName:
//         'https://hotfolder.dataox.io/images/SFD/folder5/11333965.jpg',
//       comment: null,
//       domainId: 11700797,
//       agency: 'SFD',
//       photographerName: null,
//       imageSource: '5DE',
//       delivered: false,
//       foundAt: '2025-07-28T17:37:32.585274Z',
//       difference: 26,
//       lastModifyDateFromHeader: null,
//       registeredImage: false,
//       country: 'FRANCE',
//       scrapedCountry: null,
//       domainPursuable: true,
//       blacklisted: false,
//       notImage: false,
//       messagesCount: 0,
//       reviewStatusChangedAt: null,
//       reviewStatusChangedBy: null,
//       socialAccountId: null,
//       domain: 'pedicurepodologuesete.com'
//     },
//     downloadedImageSource: {
//       header: '',
//       base64Data: null
//     }
//   },
//   img_data_989111523: {
//     imageData: {
//       id: 989111523,
//       imageId: '11333965',
//       createdAt: '2025-07-29T00:05:53.917627Z',
//       updatedAt: '2025-07-29T00:05:53.917627Z',
//       updatedBy: null,
//       status: 'PENDING',
//       imageUrl:
//         'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRw2LzIVzo17A1BZGWUDHhEa4LL_t2YUh0eLVjXfbH3_7Fcqt5L8w1UEwoc&s',
//       downloaded: false,
//       usageUrl: 'https://pedicurepodologuesete.com/pedicurie',
//       originalImageFileName:
//         'https://hotfolder.dataox.io/images/SFD/folder5/11333965.jpg',
//       comment: null,
//       domainId: 11700797,
//       agency: 'SFD',
//       photographerName: null,
//       imageSource: '5DE',
//       delivered: false,
//       foundAt: '2025-07-28T17:37:32.481990Z',
//       difference: 26,
//       lastModifyDateFromHeader: null,
//       registeredImage: false,
//       country: 'FRANCE',
//       scrapedCountry: null,
//       domainPursuable: true,
//       blacklisted: false,
//       notImage: false,
//       messagesCount: 0,
//       reviewStatusChangedAt: null,
//       reviewStatusChangedBy: null,
//       socialAccountId: null,
//       domain: 'pedicurepodologuesete.com'
//     },
//     downloadedImageSource: {
//       header: '',
//       base64Data: null
//     }
//   },
//   img_data_989111508: {
//     imageData: {
//       id: 989111508,
//       imageId: '11333965',
//       createdAt: '2025-07-29T00:05:53.912878Z',
//       updatedAt: '2025-07-29T00:05:53.912878Z',
//       updatedBy: null,
//       status: 'PENDING',
//       imageUrl:
//         'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQGmy8-34CusBkDEPAh0rpU5QTcDOVB2nGV8lvGBK6MDNeKz9IF-RzFwi5L&s',
//       downloaded: false,
//       usageUrl: 'https://pedicurepodologuesete.com/',
//       originalImageFileName:
//         'https://hotfolder.dataox.io/images/SFD/folder5/11333965.jpg',
//       comment: null,
//       domainId: 11700797,
//       agency: 'SFD',
//       photographerName: null,
//       imageSource: '5DE',
//       delivered: false,
//       foundAt: '2025-07-28T17:37:32.432461Z',
//       difference: 26,
//       lastModifyDateFromHeader: null,
//       registeredImage: false,
//       country: 'FRANCE',
//       scrapedCountry: null,
//       domainPursuable: true,
//       blacklisted: false,
//       notImage: false,
//       messagesCount: 0,
//       reviewStatusChangedAt: null,
//       reviewStatusChangedBy: null,
//       socialAccountId: null,
//       domain: 'pedicurepodologuesete.com'
//     },
//     downloadedImageSource: {
//       header: '',
//       base64Data: null
//     }
//   }
// };

// const DOMAIN_ARRAYS = [989111508, 989111523, 989111475];

class QualityControlPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      mainImageIsLoad: false,
      pageNumber: 1,
      pageSize: 50,
      workIndexes: [],
      prevDomainIDs: [],
      isVisibleConfirm: false,
      isVisibleConfirmCheck: false,
      isVisibleConfirmLegal: false,
      isVisibleLegalFirstStep: false,
      isVisibleConfirmSubmitComment: false,
      isVisibleConfirmSubmitReview: false,
      isVisibleConfirmStandBy: false,
      hasPreviousSightings: false,
      flowStatusForReview: false,
      returnedForComment: false,
      activePageChangeModal: false,
      currentStep: '',
      valueForPriorityCountry: '',
      valueForPriorityLanguage: '',
      notSelectedOtherLanguage: true,
      languageNotIdentified: false,
      imagesDataForRequest: [],
      isVisibleBlackListConfirm: false,
      isVisibleSaveChangesModal: false,
      isVisibleXlsChangesModal: false,
      currentChangesWereSaved: true,
      isVisiblePutOnFirstStep: false,
      isVisibleChangeDomainModal: false,
      legalCaseClick: false,
      copyDomainData: null,
      selectedImagesIds: [],
      selectedRowKeys: [],
      randomId: nanoid(),
      isInBlackList: false,
      confirmButtonIds: [],
      domainNameFromQuery: new URLSearchParams(window.location.search).get(
        'domainName'
      ),
      selectWebsiteAsCommercial: false,
      selectWebsiteAsNotCommercial: false,
      notAccessible: false,
      noCommercialReason: '',
      photoColumnEditing: [],
      isWithoutImageUrlChecked: false,
      legalCaseActive: false,
      priorityLanguage: '',
      notPriorityLanguage: '',
      priorityLanguageOptions: [],
      notPriorityLanguageOptions: []
    };
  }

  componentDidMount() {
    this.props.getLanguages();
    this.props.getCountriesList();
    this.startLoadData();

    this.setState({
      copyDomainData: null
    });

    if (!this.props.userInfo.userPermissions.qualityControlPermission) {
      window.location = '/403';
    }

    // this.props
    //   .getLoggedUserStatisticData(
    //     moment().format('YYYY-MM-DD'),
    //     moment().format('YYYY-MM-DD')
    //   )
    //   .then(() => {
    //     setInterval(this.runUserStatisticDataScheduler, 60000);
    //   });
  }

  componentDidUpdate(prevProps) {
    const domainChanged = prevProps.domainData?.id !== this.props.domainData?.id;
    const countryChanged =
      prevProps.domainData?.priorityCountry !==
      this.props.domainData?.priorityCountry;
    const countriesChanged =
      prevProps.getCountriesListData !== this.props.getCountriesListData;

    if (domainChanged || countryChanged || countriesChanged) {
      this.syncPriorityCountryField(domainChanged || countryChanged);
    }
  }

  syncPriorityCountryField = (force = false) => {
    const { domainData, getCountriesListData = [], form } = this.props;
    const country = domainData && domainData.priorityCountry;
    if (!country) {
      if (force) form.setFieldsValue({ priorityCountry: undefined });
      return;
    }
    if (!getCountriesListData.length) return;

    const normalizedCountry = country.toUpperCase();
    const matchedCountry = getCountriesListData.find(
      (item) =>
        item.priority &&
        [item.alpha3Code, item.fullName, item.key, item.value]
          .filter(Boolean)
          .some((value) => value.toUpperCase() === normalizedCountry)
    );
    const currentValue = form.getFieldValue('priorityCountry');
    const nextValue = matchedCountry && matchedCountry.alpha3Code;

    if (force && !nextValue) {
      form.setFieldsValue({ priorityCountry: undefined });
    } else if (nextValue && (force || currentValue !== nextValue)) {
      form.setFieldsValue({ priorityCountry: nextValue });
    }
  };

  componentWillUnmount() {
    this.props.clearDomainReviewImagesData();
  }

  runUserStatisticDataScheduler = () => {
    this.props.getLoggedUserStatisticData(
      moment().format('YYYY-MM-DD'),
      moment().format('YYYY-MM-DD')
    );
  };

  startLoadData = (domainId) => {
    const { getReserveDomainPendingForReview } = this.props;
    getReserveDomainPendingForReview('PENDING_QUALITY_CONTROL').then(() => {
      const {
        domainForReviewData,
        getDomainData,
        getFirstDomainSightings,
        getLastDomainSightings,
        getDomainsDeliveredIDs,
        getDomainsImagesStatusesIds
      } = this.props;
      if (!_.isEmpty(domainForReviewData)) {
        getDomainData(domainForReviewData[0]).then(() => {
          this.setState({
            copyDomainData: this.props.domainData,
            notAccessible: this.props.domainData.isAccessible === false
          });
          getFirstDomainSightings(domainForReviewData[0]);
          getLastDomainSightings(domainForReviewData[0]);
          getDomainsDeliveredIDs(domainForReviewData[0]).then(() => {
            getDomainsImagesStatusesIds(domainForReviewData[0], {
              key: 'id',
              order: 'asc'
            }).then(() => {
              this.getDomainsPreparedData(null, true);
            });
          });
        });
      } else {
        message.error('No domains for review');
      }
    });
  };

  getDomainData(domainId) {
    const {
      domainForReviewData,
      getDomainData,
      getFirstDomainSightings,
      getLastDomainSightings,
      getDomainsDeliveredIDs,
      getDomainsImagesStatusesIds
    } = this.props;
    const actualData = domainId ? domainId : domainForReviewData[0];
    if (!_.isEmpty(domainForReviewData)) {
      getDomainData(actualData).then(() => {
        this.setState({
          copyDomainData: this.props.domainData,
          notAccessible: this.props.domainData.isAccessible === false
        });
        getFirstDomainSightings(actualData);
        getLastDomainSightings(actualData);
        getDomainsDeliveredIDs(actualData).then(() => {
          getDomainsImagesStatusesIds(actualData, {
            key: 'id',
            order: 'asc'
          }).then(() => {
            this.getDomainsPreparedData();
          });
        });
      });
    } else {
      message.error('No domains for review');
    }
  }

  startLoadPrevData = (id) => {
    if (!_.isEmpty(this.state.prevDomainIDs)) {
      const {
        getDomainData,
        getFirstDomainSightings,
        getLastDomainSightings,
        getDomainsDeliveredIDs,
        getDomainsImagesStatusesIds
      } = this.props;
      getDomainData(id).then(() => {
        this.setState({
          copyDomainData: this.props.domainData,
          notAccessible: this.props.domainData.isAccessible === false
        });
        getFirstDomainSightings(id);
        getLastDomainSightings(id);
        getDomainsDeliveredIDs(id).then(() => {
          getDomainsImagesStatusesIds(id, {
            key: 'id',
            order: 'asc'
          }).then(() => {
            this.getDomainsPreparedData();
          });
        });
      });
    } else {
      message.error('No domains for review');
    }
  };

  getDomainsPreparedData = (status, isMounted = false) => {
    const { domainImagesStatusesIdsData } = this.props;
    const { selectedImagesIds, isInBlackList } = this.state;

    let domainData;
    let holdDataset = false;

    if (isMounted) {
      localStorage.setItem(
        'qc_data',
        JSON.stringify(domainImagesStatusesIdsData)
      );
    }

    if (!_.isEmpty(this.props.domainHoldData)) {
      holdDataset = true;
      domainData = this.props.domainHoldData;
    } else {
      domainData = this.props.domainData;
    }

    if (!_.isEmpty(domainImagesStatusesIdsData)) {
      this.setState(
        {
          // workIndexes: preparedImIds.slice((this.state.pageNumber - 1) * (this.state.pageSize - 1), this.state.pageSize).map((item) => (item.imageId)),
          workIndexes:
            (status !== 'NOT_PURSUABLE' && selectedImagesIds.length === 0) ||
            !isInBlackList
              ? domainImagesStatusesIdsData &&
                domainImagesStatusesIdsData
                  .slice(0, this.state.pageSize)
                  .map((item) => item.id)
              : this.state.workIndexes,
          pageNumber:
            (status !== 'NOT_PURSUABLE' && selectedImagesIds.length === 0) ||
            !isInBlackList
              ? 1
              : this.state.pageNumber,
          hasPreviousSightings: !_.isEmpty(
            this.props.domainDeliveredIdsData.delivered_image_ids
          ),
          returnedForComment: domainData.returnedForComment,
          flowStatusForReview:
            domainData.domainFlowStatus === 'RETURNED_FOR_REVIEW',
          holdDataset: holdDataset,
          selectedImagesIds: [],
          selectedRowKeys: []
        },
        () => {
          Promise.resolve(this.props.clearDomainReviewImagesData()).then(() => {
            for (let i = 0; i < this.state.workIndexes.length; i++) {
              this.getImagePreparedData(this.state.workIndexes[i]);
            }
          });

          // for (let i = 0; i < this.state.workIndexes.length; i++) {
          //   this.getImagePreparedData(this.state.workIndexes[i])
          // }
        }
      );
    }
  };

  handleRouteTo = (path) => {
    window.location.pathname = path;
  };

  copyToClipboard = (textToCopy) => {
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(textToCopy);
    } else {
      let textArea = document.createElement('textarea');
      textArea.value = textToCopy;
      textArea.style.position = 'fixed';
      textArea.style.left = '-999999px';
      textArea.style.top = '-999999px';
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();

      return new Promise((res, rej) => {
        document.execCommand('copy') ? res() : rej();
        textArea.remove();
      });
    }
  };

  handleCopy = (value) => (_event) => {
    this.copyToClipboard(value)
      .then(() => console.log('copied!'))
      .catch((e) => console.log('error: ', e));
  };

  saveAndGetNext = (createDraft = false) => {
    const { domainData, domainReviewImagesData } = this.props;
    const { workIndexes, photoColumnEditing } = this.state;
    if (!_.isEmpty(photoColumnEditing)) {
      message.error('Complete the URL changes!');
      return;
    }

    this.saveCurrentChangesFromDomain(domainData.id, null, null, true).then(
      (saved) => {
        if (saved === false) return;
        if (createDraft) {
          const hasNewIdenticalImage = workIndexes.some((idx) => {
            const image = domainReviewImagesData[`img_data_${idx}`]?.imageData;
            return image && image.status === 'IDENTICAL' && !image.delivered;
          });
          if (!hasNewIdenticalImage) {
            Modal.warning({
              content: 'No new identical images to include in draft',
              okText: 'OK'
            });
            return;
          }
          this.prepairImagesDataForRequest('legal').then(() => {
            this.changeDomain('next');
          });
          return;
        }
        this.changeDomain('next');
      }
    );
  };

  toggleDomainAccessibilityAndGetNext = () => {
    this.setState((state) => ({ notAccessible: !state.notAccessible }), () => {
      this.saveAndGetNext(false);
    });
  };

  getImagePreparedData = (imageID, callback = null) => {
    let imageDataObject = {};

    this.props.getImageData(imageID).then(() => {
      imageDataObject = _.merge({}, imageDataObject, {
        [`img_data_${imageID}`]: {
          imageData: this.props.imageData,
          downloadedImageSource: {
            header: '',
            base64Data: null
          }
        }
      });

      if (this.props.imageData.downloaded) {
        this.props.getDownloadedImagesData(imageID).then(() => {
          if (_.isEmpty(this.props.downloadedImageDataErrorMessage)) {
            const downloadedImageBlob = new Blob(
              [this.props.downloadedImageData],
              {
                type: this.props.downloadedImageData
              }
            );

            let reader = new FileReader();
            reader.readAsDataURL(downloadedImageBlob);
            reader.onloadend = () => {
              let base64data = reader.result;
              imageDataObject[`img_data_${imageID}`].downloadedImageSource = {
                header: this.props.downloadedImageHeaderData,
                base64Data: base64data
              };

              Promise.resolve(
                this.props.changeDomainReviewImagesData(imageDataObject, null)
              ).then(() => {
                callback && callback();
              });
            };
          } else {
            Promise.resolve(
              this.props.changeDomainReviewImagesData(imageDataObject, null)
            ).then(() => {
              callback && callback();
            });
          }
        });
      } else {
        Promise.resolve(
          this.props.changeDomainReviewImagesData(imageDataObject, null)
        ).then(() => {
          callback && callback();
        });
      }
    });
  };

  // prepareCountImagesByStatus = (statusType = null) => {
  //   if (!_.isEmpty(this.props.domainImagesStatusesIdsData)) {
  //     if (statusType) {
  //       return this.props.domainImagesStatusesIdsData[statusType].length
  //     } else {
  //       let allImagesCount = 0
  //       _.forEach(Object.keys(this.props.domainImagesStatusesIdsData), (statusKey) => {
  //         allImagesCount += this.props.domainImagesStatusesIdsData[statusKey].length
  //       })
  //
  //       return allImagesCount
  //     }
  //   } else {
  //     return 0
  //   }
  // }

  prepareCountImagesByStatus = (statusType = null) => {
    const data = JSON.parse(localStorage.getItem('qc_data'));

    if (!_.isEmpty(data)) {
      if (statusType) {
        return _.filter(data, (item) => item.status === statusType).length;
      } else {
        return data.length;
      }
    } else {
      return 0;
    }
  };

  prepareLanguageOptions = (priority = false) => {
    let sortedLanguages = _.orderBy(this.props.languagesData, 'label', 'asc');
    let languageOptions = _.filter(
      sortedLanguages,
      (lang) => lang.priority === priority
    );

    if (this.state.priorityLanguageOptions.length > 0 && priority) {
      return _.map(this.state.priorityLanguageOptions, (op, index) => (
        <Option value={op.code} key={`${op.code}_${index}`}>
          {op.label}
        </Option>
      ));
    }

    if (this.state.notPriorityLanguageOptions.length > 0 && !priority) {
      return _.map(this.state.notPriorityLanguageOptions, (op, index) => (
        <Option value={op.code} key={`${op.code}_${index}`}>
          {op.label}
        </Option>
      ));
    }

    return _.map(languageOptions, (op, index) => (
      <Option value={op.code} key={`${op.code}_${index}`}>
        {op.label}
      </Option>
    ));
  };

  changePriorityCountry = (value, fieldValue) => {
    let lang = null;
    let priorityLangOptions = [];
    let notPriorityLangOptions = [];
    let lowercase = '';
    let capitalizeCase = '';

    if (value) {
      lowercase =
        value !== 'UNITED STATES OF AMERICA' ? value.toLowerCase() : value;
      capitalizeCase =
        lowercase !== 'united kingdom'
          ? lowercase.charAt(0).toUpperCase() + lowercase.slice(1)
          : 'United Kingdom';
    }

    if (fieldValue === 'priorityCountry') {
      let sortedLanguages = _.orderBy(this.props.languagesData, 'label', 'asc');
      let languageOptions = _.filter(
        sortedLanguages,
        (lang) => lang.priority === true
      );

      languageOptions.forEach((language) => {
        if (language.countries.includes(capitalizeCase)) {
          lang = language.code;
          priorityLangOptions.push(language);

          if (value === 'UNITED KINGDOM' && lang === 'en') {
            this.setState({
              priorityLanguage: language.code
            });
          }

          if (value !== 'UNITED KINGDOM') {
            this.setState({
              priorityLanguage: language.code
            });
          }
        }
      });

      if (!lang) {
        let languageNotPrioOptions = _.filter(
          sortedLanguages,
          (lang) => lang.priority === false
        );
        languageNotPrioOptions.forEach((language) => {
          if (language.countries.includes(capitalizeCase)) {
            lang = language.code;
            notPriorityLangOptions.push(language);
            this.setState({
              notPriorityLanguage: language.code
            });
          }
        });
      }

      this.setState({
        priorityLanguageOptions: priorityLangOptions,
        notPriorityLanguageOptions: notPriorityLangOptions
      });
    }

    this.setState({
      valueForPriorityCountry: value,
      currentChangesWereSaved: false
    });
  };

  changePriorityLanguage = (value, fieldValue) => {
    // let language = null;
    if (fieldValue === 'priorityLanguage') {
      this.setState({
        priorityLanguage: value
      });
    } else {
      this.setState({
        notPriorityLanguage: value
      });
    }

    this.setState({
      valueForPriorityLanguage: value,
      currentChangesWereSaved: false
    });
  };

  handleChangePage = (page, pageSize) => {
    Promise.resolve(this.props.clearDomainReviewImagesData()).then(() => {
      this.setState(
        {
          selectedRowKeys: [],
          pageNumber: page,
          workIndexes: this.props.domainImagesStatusesIdsData
            .slice((page - 1) * this.state.pageSize, this.state.pageSize * page)
            .map((item) => item.id)
        },
        () => {
          for (let i = 0; i < this.state.workIndexes.length; i++) {
            this.getImagePreparedData(this.state.workIndexes[i]);
          }
        }
      );
    });
  };

  // prepareCommentColumn = (imageData) => {
  //   if (!_.isEmpty(imageData.comment)) {
  //     return (
  //       <div className="comment-icon">
  //         <Tooltip placement="topLeft" title={imageData.comment}>
  //           <Icon type="form" />
  //         </Tooltip>
  //       </div>
  //     );
  //   } else {
  //     return '';
  //   }
  // };

  handleAgree = (imageId, newStatus, imageData) => {
    // message.success("Need to save");
    this.props
      .updateImageStatus(
        {
          delivered: imageData.delivered,
          id: imageData.id,
          status: newStatus
        },
        imageData.id
      )
      .then(() => {
        if (!_.isEmpty(this.props.updateImageStatusErrorMessage)) {
          message.error(this.props.updateImageStatusErrorMessage, 5);
        } else {
          // if (newStatus === QC_IMAGE_STATUSES.identical) {
          //   this.props.changeDeliveredData(
          //     {
          //       delivered: true,
          //       id: imageData.id,
          //       status: newStatus
          //     },
          //     imageData.id
          //   );
          // }

          let cloneImageData = _.cloneDeep(
            this.props.domainReviewImagesData[`img_data_${imageId}`]
          );
          if (cloneImageData && cloneImageData.imageData) {
            cloneImageData.imageData.status = newStatus;
            this.props.changeDomainReviewImagesData(
              cloneImageData,
              `img_data_${imageId}`
            );
            this.setState({
              currentChangesWereSaved: false
            });
          }
        }
      });
  };

  handleCancelSubmitCommit = () => {
    this.setState(
      {
        isVisibleConfirmSubmitComment: false
      },
      () => {
        Modal.destroyAll();
      }
    );
  };

  handleAgreeSubmitCommit = () => {
    this.handleDetailsSave();
  };

  renderConfirmSubmitCommitModal = () => {
    const { isVisibleConfirmSubmitComment } = this.state;

    return Modal.confirm({
      visible: isVisibleConfirmSubmitComment,
      title: '',
      content: `Are you sure you want to submit comment`,
      keyboard: false,
      maskClosable: false,
      okText: 'Ok',
      cancelText: 'Cancel',
      onOk: () => this.handleAgreeSubmitCommit(),
      onCancel: () => this.handleCancelSubmitCommit()
    });
  };

  handleSubmitComment = () => {
    this.setState(
      {
        isVisibleConfirmSubmitComment: true
      },
      () => {
        this.renderConfirmSubmitCommitModal();
      }
    );
  };

  handleCancel = () => {
    this.setState(
      {
        isVisibleConfirm: false
      },
      () => {
        Modal.destroyAll();
      }
    );
  };

  handleImageStatusChange = (value, option, imageData) => {
    const { setBulkChanges } = this.props;
    const { selectedImagesIds } = this.state;
    const id =
      !_.isEmpty(selectedImagesIds) &&
      _.map(selectedImagesIds, (image) => image.id);

    const changedImageStatus = {
      delivered: imageData.delivered,
      id: imageData.id,
      status: value
    };

    if (value === 'NOT_PURSUABLE') {
      Promise.resolve(this.handleAgree(imageData.id, value, imageData))
        .then(() => {
          this.props.getDomainsImagesStatusesIds(
            this.props.domainForReviewData[0],
            {
              key: 'id',
              order: 'asc'
            }
          );
        })
        .then(() => {
          this.props.clearDomainReviewImagesData();
        })
        .then(() => {
          setTimeout(() => {
            this.getDomainsPreparedData('NOT_PURSUABLE');
          }, 3000);
        });
    } else {
      this.handleAgree(imageData.id, value, imageData);
    }

    if (id && id.length > 0) {
      Promise.resolve(
        setBulkChanges({
          ids: id,
          status: value
        })
      )
        .then(() => {
          this.props.getDomainsImagesStatusesIds(
            this.props.domainForReviewData[0],
            {
              key: 'id',
              order: 'asc'
            }
          );
        })
        .then(() => {
          this.props.clearDomainReviewImagesData();
        })
        .then(() => {
          setTimeout(() => {
            this.getDomainsPreparedData();
          }, 3000);
        });
    }

    const currentImagesFromStorage =
      JSON.parse(localStorage.getItem('updateImagesDataStatus')) || [];
    currentImagesFromStorage.push(changedImageStatus);
    localStorage.setItem(
      'updateImagesDataStatus',
      JSON.stringify(currentImagesFromStorage)
    );
  };

  handleSendStatus = (status, id, delivered) => {
    this.props
      .updateImageStatus(
        {
          delivered: delivered,
          id: id,
          status: status
        },
        id
      )
      .then(() => {
        if (!_.isEmpty(this.props.updateImageStatusErrorMessage)) {
          message.error(this.props.updateImageStatusErrorMessage, 5);
        } else {
          let cloneImageData = _.cloneDeep(
            this.props.domainReviewImagesData[`img_data_${id}`]
          );
          if (cloneImageData && cloneImageData.imageData) {
            cloneImageData.imageData.status = status;
            this.props.changeDomainReviewImagesData(
              cloneImageData,
              `img_data_${id}`
            );
            this.setState({
              currentChangesWereSaved: false
            });
          }
        }
      });

    const array = [];
    array.push(id);
    this.setState({
      confirmButtonIds: [...this.state.confirmButtonIds, ...array]
    });
  };

  prepareStatusColumn = (imageData) => {
    const { delivered } = imageData;
    let findedIndex = false;

    findedIndex = _.filter(this.state.confirmButtonIds, (item) => {
      return item === imageData.id;
    });

    const classNameButton = classNames([
      'confirm__button',
      findedIndex[0] ? 'confirm__finded' : ''
    ]);

    const availableStatuses = getQcImageStatuses(
      this.props.userInfo.userPermissions.legitimateStatusPermission
    );

    return (
      imageData && (
        <div
          className={`d-f-r-ac-jc ${imageData.status.toLowerCase()} ${
            !imageData.delivered ? 'delivered' : ''
          }`}
        >
          <div className='d-f-c-sb-center'>
            <Select
              style={{ width: 150, marginBottom: 15 }}
              value={imageData.status}
              onChange={(value, option) => {
                this.handleImageStatusChange(value, option, imageData);
              }}
              disabled={delivered}
            >
              {_.map(Object.keys(availableStatuses), (itemKey) => {
                const statuses = availableStatuses;
                return (
                  <Option key={statuses[itemKey]} value={statuses[itemKey]}>
                    {statuses[itemKey]}
                  </Option>
                );
              })}
            </Select>
            <span style={{ marginBottom: 15 }}>
              <strong>{imageData.agency}</strong>
            </span>
            <span>
              <strong>{imageData.imageId}</strong>
            </span>
          </div>
          <div className={classNameButton}>
            <button
              onClick={() =>
                this.handleSendStatus(imageData.status, imageData.id, delivered)
              }
            >
              Confirm Status
            </button>
          </div>
        </div>
      )
    );
  };

  renderImagePopover = (imageDataWorkData, _size, border = false) => {
    /** get UPLOADED and ONLINE image links */

    const imageLink = imageDataWorkData && imageDataWorkData.imageData.usageUrl;
    const uploadImageLink =
      imageDataWorkData &&
      `${imageDataWorkData.imageData.originalImageFileName}?introlab`;

    /** check facebook.com domain */

    const { getFacebookImageUrl, facebookImageUrl, facebookImageUrlError } =
      this.props;
    const domain = imageDataWorkData.imageData.domain;
    const isFacebookDomain =
      domain === 'facebook.com' || domain?.includes('facebook.com');

    /** Render ------------------------------------------------------------------------- */

    return (
      <ImageAwarePopover
        imageDataWorkData={imageDataWorkData}
        isFacebookDomain={isFacebookDomain}
        imageLink={imageLink}
        uploadImageLink={uploadImageLink}
        border={border}
        fetcher={getFacebookImageUrl}
        errorMessage={facebookImageUrlError}
        data={facebookImageUrl}
      />
    );
  };

  prepareImagesColumn = (imageDataWorkData) => {
    const { createdAt, updatedAt, status } =
      imageDataWorkData && imageDataWorkData.imageData;
    const checkImageDate =
      moment(createdAt).isAfter(updatedAt) && status === 'IDENTICAL';

    return (
      <div className='images-wrapper'>
        {checkImageDate && <Icon type='check-circle' />}
        {this.renderImagePopover(imageDataWorkData, 150)}
      </div>
    );
  };

  handlePhotoColumnEdit = (id, flag) => {
    let photoColumnEditing = _.cloneDeep(this.state.photoColumnEditing);

    if (flag) {
      photoColumnEditing.push(id);
    } else {
      let elIdx = photoColumnEditing.indexOf(id);

      if (elIdx !== -1) photoColumnEditing.splice(elIdx, 1);
    }

    this.setState(
      {
        photoColumnEditing: photoColumnEditing
      },
      () => {
        _.isEmpty(this.state.photoColumnEditing)
          ? this.setState({ currentChangesWereSaved: true })
          : this.setState({ currentChangesWereSaved: false });
      }
    );
  };

  prepareTableData = () => {
    const { workIndexes, isWithoutImageUrlChecked } = this.state;
    const { domainReviewImagesData } = this.props;

    let tableData = [];

    if (
      !_.isEmpty(workIndexes) &&
      !_.isEmpty(domainReviewImagesData) &&
      Object.keys(domainReviewImagesData).length === workIndexes.length &&
      !isWithoutImageUrlChecked
    ) {
      _.forEach(workIndexes, (wID) => {
        tableData.push({
          id:
            domainReviewImagesData &&
            domainReviewImagesData[`img_data_${wID}`] &&
            domainReviewImagesData[`img_data_${wID}`].imageData &&
            domainReviewImagesData[`img_data_${wID}`].imageData.id,
          // comment: this.prepareCommentColumn(domainReviewImagesData[`img_data_${wID}`].imageData),
          imageStatus: this.prepareStatusColumn(
            domainReviewImagesData[`img_data_${wID}`].imageData
          ),
          images: this.prepareImagesColumn(
            domainReviewImagesData[`img_data_${wID}`]
          ),
          photographerName: (
            <PhotographerColumn
              photographerName={
                domainReviewImagesData[`img_data_${wID}`].imageData
              }
              sendUpdatedImageURL={this.props.sendUpdatedImageURL}
              getImagePreparedData={this.getImagePreparedData}
              handlePhotoColumnEdit={this.handlePhotoColumnEdit}
            />
          ),
          sightingsData: (
            <SightingsModal
              imageData={domainReviewImagesData[`img_data_${wID}`].imageData}
              getImagePreparedData={this.getImagePreparedData}
              getDomainsPreparedData={this.getDomainsPreparedData}
              url={window.location.pathname}
            />
          ),
          difference: (
            <div style={{ textAlign: 'center' }}>
              {domainReviewImagesData[`img_data_${wID}`].imageData.difference}
            </div>
          )
        });
      });

      return tableData;
    } else if (
      !_.isEmpty(workIndexes) &&
      !_.isEmpty(domainReviewImagesData) &&
      Object.keys(domainReviewImagesData).length === workIndexes.length &&
      isWithoutImageUrlChecked
    ) {
      _.forEach(workIndexes, (wID) => {
        if (!domainReviewImagesData[`img_data_${wID}`].imageData.imageUrl) {
          tableData.push({
            id:
              domainReviewImagesData &&
              domainReviewImagesData[`img_data_${wID}`] &&
              domainReviewImagesData[`img_data_${wID}`].imageData &&
              domainReviewImagesData[`img_data_${wID}`].imageData.id,
            imageStatus: this.prepareStatusColumn(
              domainReviewImagesData[`img_data_${wID}`].imageData
            ),
            images: this.prepareImagesColumn(
              domainReviewImagesData[`img_data_${wID}`]
            ),
            photographerName: (
              <PhotographerColumn
                photographerName={
                  domainReviewImagesData[`img_data_${wID}`].imageData
                }
                sendUpdatedImageURL={this.props.sendUpdatedImageURL}
                getImagePreparedData={this.getImagePreparedData}
                handlePhotoColumnEdit={this.handlePhotoColumnEdit}
              />
            ),
            sightingsData: (
              <SightingsModal
                imageData={domainReviewImagesData[`img_data_${wID}`].imageData}
                getImagePreparedData={this.getImagePreparedData}
                getDomainsPreparedData={this.getDomainsPreparedData}
                url={window.location.pathname}
              />
            )
          });
        }
      });
      return tableData;
    } else {
      return [];
    }
  };

  handleChangeFilter = (filterKey) => {
    const [key, order] = filterKey.split('_');

    const sortingOptions = {
      [key]: order
    };

    const data = JSON.parse(localStorage.getItem('qc_data'));

    let paginationOptions = {
      page: null,
      size: data.length
    };

    Promise.resolve(
      this.props.filterSightings(
        this.props.domainForReviewData[0],
        {},
        paginationOptions,
        sortingOptions
      )
    ).then(() => {
      Promise.resolve(this.props.clearDomainReviewImagesData()).then(() => {
        this.getDomainsPreparedData();
      });
    });
  };

  handleFilterWithoutImageUrl = (filterKey) => {
    if (filterKey.target.checked)
      this.setState({
        isWithoutImageUrlChecked: true
      });
    else
      this.setState({
        isWithoutImageUrlChecked: false
      });
  };

  handleOnSightingsClick = (imageStatus) => {
    const { domainReviewImagesData } = this.props;
    const { workIndexes } = this.state;
    let elementIndex = _.findIndex(this.props.domainImagesStatusesIdsData, {
      status: imageStatus
    });
    const allImagesLoaded =
      Object.keys(domainReviewImagesData).length === workIndexes.length;

    if (elementIndex !== -1) {
      const pageNumber =
        elementIndex === 0 ? 1 : Math.ceil(elementIndex / this.state.pageSize);
      this.handleChangePage(pageNumber);

      let timerId;
      if (
        !_.isEmpty(this.props.domainImagesStatusesIdsData) &&
        !pageNumber !== 1 &&
        allImagesLoaded &&
        !_.isEmpty(workIndexes) &&
        !_.isEmpty(domainReviewImagesData) &&
        Object.keys(domainReviewImagesData).length === workIndexes.length
      ) {
        timerId = setInterval(() => {
          this.scrollToSightings(elementIndex);
        }, 3000);
      } else if (!_.isEmpty(this.props.domainImagesStatusesIdsData)) {
        this.scrollToSightings(elementIndex);
      }

      // // повторить с интервалом 2 секунды
      // let timerId = setInterval(() => {
      //   const findDom = ReactDOM.findDOMNode(this).getElementsByClassName(
      //     `scroll_${this.props.domainImagesStatusesIdsData[elementIndex].id}`
      //   );
      //   if (!_.isEmpty(findDom)) {
      //     findDom[0].scrollIntoView({ block: "center", behavior: "smooth" });
      //     clearInterval(timerId);
      //   }
      // }, 1000);

      setTimeout(() => {
        clearInterval(timerId);
      }, 9000);
    }
  };

  scrollToSightings = (elementIndex) => {
    const findDom = document.getElementsByClassName(
      `scroll_${this.props.domainImagesStatusesIdsData[elementIndex].id}`
    );
    if (!_.isEmpty(findDom)) {
      findDom[0].scrollIntoView({ block: 'center', behavior: 'smooth' });
    }
  };

  handleDetailsSave = (asReview = false) => {
    const { valueForPriorityCountry, valueForPriorityLanguage } = this.state;
    this.props.form.validateFields((err, values) => {
      if (err) {
        return;
      }

      if (values.otherCountries === valueForPriorityCountry) {
        values.priorityCountry = null;
      } else if (values.priorityCountry === valueForPriorityCountry) {
        values.otherCountries = null;
      }

      if (values.otherLanguage === valueForPriorityLanguage) {
        values.priorityLanguage = null;
      } else if (values.priorityLanguage === valueForPriorityLanguage) {
        values.otherLanguage = null;
      }

      let cloneDomainData = _.cloneDeep(this.props.domainData);
      cloneDomainData = _.merge({}, cloneDomainData, values);

      if (asReview) {
        // message.success('You press review save')
        this.props.setReturnedForReview(cloneDomainData).then(() => {
          if (!_.isEmpty(this.props.setReturnedForReviewErrorMessage)) {
            message.error(this.props.setReturnedForReviewErrorMessage);
          } else {
            message.success('Submit as review successfully');
          }
        });
      } else {
        // message.success('You press comment save')
        // if (!_.isEmpty(this.props.domainData, cloneDomainData)) {
        //   message.success('Not isEqual')
        // } else {
        //   message.success('isEqual')
        // }
        cloneDomainData.returnedForComment = true;
        // this.props.setReturnedForCommentTrue(cloneDomainData).then(() => {
        this.props.saveDomainDataAsReview(cloneDomainData).then(() => {
          // if (!_.isEmpty(this.props.setReturnedForCommentTrueErrorMessage)) {
          //   message.error(this.props.setReturnedForCommentTrueErrorMessage)
          // } else {
          //   message.success('Submit as comment successfully')
          // }
          if (!_.isEmpty(this.props.updateDomainAsReviewDataErrorMessage)) {
            message.error(this.props.updateDomainAsReviewDataErrorMessage);
          } else {
            message.success('Submit as comment successfully');
            this.props.changeDomainDataInRedux(
              this.props.updateDomainAsReviewData
            );
          }
        });
      }
    });
  };

  handleSubmitForReview = () => {
    Promise.resolve(this.handleDetailsSave(true)).then(() => {
      this.changeDomain('next');
    });
  };

  // handleAgreeLegal = (xls) => {
  //   const { reportStatus } = this.props;
  //   if (reportStatus && !reportStatus.result) {
  //     message.error('Delivery failed');
  //   } else {
  //     message.success('Delivered successfully');
  //   }

  //   this.prepairImagesDataForRequest(xls);
  // };

  handleAgreeLegal = (xls) => {
    const { reportStatus } = this.props;

    const { photoColumnEditing } = this.state;

    if (!_.isEmpty(photoColumnEditing)) {
      message.error('Complete the URL changes!');
      return;
    }

    if (reportStatus && !reportStatus.result) {
      message.error('Delivery failed');
    } else {
      message.success('Delivered successfully');
    }

    this.prepairImagesDataForRequest(xls);
  };

  // handleCancelLegal = () => {
  //   this.setState(
  //     {
  //       isVisibleConfirmLegal: false
  //     },
  //     () => {
  //       Modal.destroyAll();
  //     }
  //   );
  // };

  // renderConfirmLegalModal = xls => {
  //   const { currentChangesWereSaved } = this.state;
  //   if (!currentChangesWereSaved) {
  //     this.setState({
  //       legalCaseClick: true
  //     });
  //     this.renderConfirmFirstStep(xls);
  //   } else {
  //     this.renderConfirmSecondStep(xls);
  //   }
  // };

  // renderConfirmSecondStep = xls => {
  //   const { isVisibleConfirmLegal } = this.state;

  //   return Modal.confirm({
  //     visible: isVisibleConfirmLegal,
  //     title: "",
  //     content: `Would you like to create a Legal Case?`,
  //     keyboard: false,
  //     maskClosable: false,
  //     okText: "Ok",
  //     cancelText: "Cancel",
  //     onOk: () => this.handleAgreeLegal(xls),
  //     onCancel: () => this.handleCancelLegal()
  //   });
  // };

  // renderConfirmFirstStep = xls => {
  //   const { isVisibleLegalFirstStep } = this.state;

  //   return Modal.confirm({
  //     visible: isVisibleLegalFirstStep,
  //     title: "",
  //     content: `Would you like to save changes?`,
  //     keyboard: false,
  //     maskClosable: false,
  //     okText: "Save",
  //     cancelText: "Proceed without changes",
  //     onOk: () => this.handleAgreeFirstLegalStep(xls),
  //     onCancel: () => this.handleCancelFirstLegalStep(xls)
  //   });
  // };

  // handleAgreeFirstLegalStep = xls => {
  //   const { domainData } = this.props;
  //   const domainId = domainData && domainData.id;

  //   Promise.resolve(this.saveCurrentChangesFromDomain(domainId)).then(() => {
  //     setTimeout(() => {
  //       this.renderConfirmSecondStep(xls);
  //       this.setState({
  //         currentChangesWereSaved: true
  //       });
  //     }, 1000);
  //   });
  // };

  // handleCancelFirstLegalStep = xls => {
  //   this.renderConfirmSecondStep(xls);
  //   this.setState({
  //     isVisibleLegalFirstStep: false
  //   });
  // };

  handleClickStandBy = () => {
    this.setState(
      {
        isVisibleConfirmStandBy: true
      },
      () => {
        this.renderConfirmStandByModal();
      }
    );
  };

  handleAgreeStandBy = () => {
    const {
      updateImagesHoldData,
      updateDomainHoldData,
      updateDomainHoldDataErrorMessage,
      addToDeliveredData
    } = this.props;
    let changeDomainData = this.props.form.getFieldsValue();
    let preparedToHold = _.merge({}, this.props.domainData, changeDomainData);

    if (changeDomainData.otherCountries === undefined) {
      preparedToHold.otherCountries = null;
    } else if (changeDomainData.priorityCountry === undefined) {
      preparedToHold.priorityCountry = null;
    }

    if (changeDomainData.otherLanguage === undefined) {
      preparedToHold.otherLanguage = null;
    } else if (changeDomainData.priorityLanguage === undefined) {
      preparedToHold.priorityLanguage = null;
    }

    updateDomainHoldData(preparedToHold)
      .then(() => {
        updateImagesHoldData(addToDeliveredData);
      })
      .then(() => {
        if (!_.isEmpty(updateDomainHoldDataErrorMessage)) {
          message.error(updateDomainHoldDataErrorMessage);
        } else {
          message.success('Domain data hold successfully');
        }
      });
  };

  // handleCancelStandBy = () => {
  //   this.setState(
  //     {
  //       isVisibleConfirmStandBy: false
  //     },
  //     () => {
  //       Modal.destroyAll();
  //     }
  //   );
  // };

  // renderConfirmStandByModal = () => {
  //   const { currentChangesWereSaved } = this.state;
  //   if (!currentChangesWereSaved) {
  //     this.renderStandByFirstStep();
  //   } else {
  //     this.renderStandBySecondStep();
  //   }
  // };

  // renderStandByFirstStep = () => {
  //   const { isVisiblePutOnFirstStep } = this.state;

  //   return Modal.confirm({
  //     visible: isVisiblePutOnFirstStep,
  //     title: "",
  //     content: `Would you like to save changes?`,
  //     keyboard: false,
  //     maskClosable: false,
  //     okText: "Save",
  //     cancelText: "Proceed without changes",
  //     onOk: () => this.handleAgreeFirstStepPutOn(),
  //     onCancel: () => this.handleCancelFirstStepPutOn()
  //   });
  // };

  // handleAgreeFirstStepPutOn = () => {
  //   const { domainData } = this.props;
  //   const domainId = domainData && domainData.id;

  //   Promise.resolve(this.saveCurrentChangesFromDomain(domainId)).then(() => {
  //     setTimeout(() => {
  //       this.renderStandBySecondStep();
  //       this.setState({
  //         currentChangesWereSaved: true
  //       });
  //     }, 1000);
  //   });
  // };

  // handleCancelFirstStepPutOn = () => {
  //   this.renderConfirmSecondStep();
  //   this.setState({
  //     isVisiblePutOnFirstStep: false
  //   });
  // };

  // renderStandBySecondStep = () => {
  //   const { isVisibleConfirmStandBy } = this.state;

  //   return Modal.confirm({
  //     visible: isVisibleConfirmStandBy,
  //     title: "",
  //     content: `Are you sure you want to put on stand by?`,
  //     keyboard: false,
  //     maskClosable: false,
  //     okText: "Ok",
  //     cancelText: "Cancel",
  //     onOk: () => this.handleAgreeStandBy(),
  //     onCancel: () => this.handleCancelStandBy()
  //   });
  // };

  createLegalCases = () => {
    this.setState(
      {
        isVisibleConfirmLegal: true
      },
      () => {
        this.renderConfirmLegalModal();
      }
    );
  };

  prepareErrorMessage = (text) => {
    return <div className='message-component'>{text}</div>;
  };

  showModal = () => {
    this.setState({
      activePageChangeModal: true
    });
  };

  handleModalOk = () => {
    const { currentStep } = this.state;
    this.changeDomain(currentStep);
    this.setState({
      activePageChangeModal: false
    });
  };

  handleModalCancel = () => {
    this.setState({
      activePageChangeModal: false
    });
  };

  changeStep = (step) => {
    Promise.resolve(
      this.setState({
        currentStep: step
      })
    ).then(() => {
      this.showChangeDomainModal();
    });
  };

  nextItem = (array) => {
    let i = 0;
    i = i + 1;
    i = i % array.length;

    return array[i];
  };

  changeDomain = (step) => {
    this.setState({
      notPriorityLanguageOptions: [],
      priorityLanguageOptions: [],
      priorityLanguage: '',
      notPriorityLanguage: '',
      legalCaseActive: false
    });

    const { clearDomainReviewImagesData, clearDeliveredData, domainData } =
      this.props;

    const { prevDomainIDs } = this.state;

    if (step === 'prev' && prevDomainIDs.length > 0) {
      const lastDomainId = prevDomainIDs[prevDomainIDs.length - 1];
      Promise.all([clearDomainReviewImagesData(), clearDeliveredData()]).then(
        () => {
          setTimeout(() => {
            prevDomainIDs.pop();
          }, 100);
          this.startLoadPrevData(lastDomainId);
        }
      );
    } else {
      Promise.all([clearDomainReviewImagesData(), clearDeliveredData()]).then(
        () => {
          let clonePrevDomainIDs = _.cloneDeep(prevDomainIDs);
          clonePrevDomainIDs.push(domainData.id);
          this.setState(
            {
              prevDomainIDs: clonePrevDomainIDs
            },
            () => {
              this.startLoadData();
            }
          );
        }
      );
    }

    this.setState({
      valueForPriorityCountry: '',
      valueForPriorityLanguage: ''
    });

    this.props.form.resetFields();

    localStorage.removeItem('updateImagesDataStatus');
  };

  showChangeDomainModal = () => {
    const { isVisibleChangeDomainModal, currentChangesWereSaved, currentStep } =
      this.state;

    if (!currentChangesWereSaved) {
      return Modal.confirm({
        visible: isVisibleChangeDomainModal,
        title: '',
        content: `Would you like to save changes before going to another domain?`,
        keyboard: false,
        maskClosable: false,
        okText: 'Save',
        cancelText: 'Proceed without changes',
        onOk: () => this.handleOkNextDomain(currentStep),
        onCancel: () => {
          this.changeDomain(currentStep);
          this.setState({
            currentChangesWereSaved: true
          });
        }
      });
    } else {
      this.changeDomain(currentStep);
      this.setState({
        currentChangesWereSaved: true
      });
    }
  };

  handleOkNextDomain = () => {
    const { domainData } = this.props;
    const { currentStep, photoColumnEditing } = this.state;
    const domainId = domainData && domainData.id;

    if (!_.isEmpty(photoColumnEditing)) {
      message.error('Complete the URL changes!');
      return;
    }

    Promise.resolve(this.saveCurrentChangesFromDomain(domainId)).then(() => {
      setTimeout(() => {
        this.changeDomain(currentStep);
        this.setState({
          currentChangesWereSaved: true
        });
      }, 1000);
    });
  };

  getSpinStatus = () => {
    const {
      domainReserveDataIsFetching,
      domainDeliveredIdsDataIsFetching,
      domainImagesStatusesIdsDataIsFetching,
      domainDataIsFetching,
      languagesDataIsFetching,
      lastDomainSightingsDataIsFetching,
      domainForReviewDataIsFetching,
      imageDataIsFetching,
      downloadedImageDataIsFetching,
      updateImagesDataIsFetching,
      setReturnedForCommentTrueIsFetching,
      setReturnedForReviewIsFetching,
      updateDomainAsReviewDataIsFetching,
      domainHoldDataIsFetching,
      updateDomainHoldDataIsFetching,
      deleteDomainHoldDataIsFetching,
      // domainReviewImagesData,
      blackList
    } = this.props;

    // const allImagesLoaded =
    //   Object.keys(domainReviewImagesData).length ===
    //   this.state.workIndexes.length;

    const addingToBlackList = blackList && blackList.isLoading;

    return (
      domainReserveDataIsFetching ||
      domainDeliveredIdsDataIsFetching ||
      domainImagesStatusesIdsDataIsFetching ||
      domainDataIsFetching ||
      languagesDataIsFetching ||
      lastDomainSightingsDataIsFetching ||
      domainForReviewDataIsFetching ||
      imageDataIsFetching ||
      downloadedImageDataIsFetching ||
      updateImagesDataIsFetching ||
      setReturnedForCommentTrueIsFetching ||
      setReturnedForReviewIsFetching ||
      updateDomainAsReviewDataIsFetching ||
      domainHoldDataIsFetching ||
      updateDomainHoldDataIsFetching ||
      deleteDomainHoldDataIsFetching ||
      // !allImagesLoaded ||
      addingToBlackList
    );
  };

  resetContactDetailsFields = () => {
    let changeDomainData = this.props.form.getFieldsValue();
    _.forEach(Object.keys(changeDomainData), (key) => {
      if (
        key === 'companyName' ||
        key === 'contactFormLink' ||
        key === 'email' ||
        key === 'facebookLink' ||
        key === 'phoneNumber' ||
        key === 'postcode' ||
        key === 'facebookLink' ||
        key === 'street' ||
        key === 'city'
      ) {
        changeDomainData[key] = undefined;
      }
    });

    this.props.form.setFieldsValue(changeDomainData);
  };

  prepairImagesDataForRequest = (xls) => {
    const { domainData, saveChanges, sendReportForImages, setDeliveredStatus } =
      this.props;

    const domainId = domainData.id;
    const newDataFromDOmain = saveChanges.updateDomainsData;
    const actualDomainData = newDataFromDOmain ? newDataFromDOmain : domainData;

    return Promise.all([
      sendReportForImages(domainId),
      setDeliveredStatus(actualDomainData, domainId)
    ]);
  };

  // renderSaveXlsModal = xls => {
  //   const { isVisibleXlsChangesModal, currentChangesWereSaved } = this.state;
  //   const { domainData } = this.props;
  //   const id = domainData.id;
  //   const oldData = true;

  //   if (!currentChangesWereSaved) {
  //     return Modal.confirm({
  //       visible: isVisibleXlsChangesModal,
  //       title: "",
  //       content: `Would you like to save changes?`,
  //       keyboard: false,
  //       maskClosable: false,
  //       okText: "Save",
  //       cancelText: "Export without changes",
  //       onOk: () => {
  //         this.handleOkForXlsModal(id, xls);
  //       },
  //       onCancel: () => this.prepairImagesDataForRequest(xls, oldData)
  //     });
  //   }

  //   this.prepairImagesDataForRequest(xls, oldData);
  // };

  // handleOkForXlsModal = (id, xls) => {
  //   const { domainData } = this.props;
  //   Promise.resolve(this.saveCurrentChangesFromDomain(domainData.id)).then(
  //     () => {
  //       setTimeout(() => {
  //         this.prepairImagesDataForRequest(xls);
  //         this.setState({
  //           currentChangesWereSaved: true
  //         });
  //       }, 1000);
  //     }
  //   );
  // };

  checkChangesInCompanyDetails = () => {
    this.setState({
      currentChangesWereSaved: false
    });
  };

  renderBlackListModal = (id) => {
    const { domainData } = this.props;
    const { blacklisted } = !_.isEmpty(domainData) && domainData;
    const { isVisibleBlackListConfirm } = this.state;
    const domainName = domainData && domainData.domain;

    return Modal.confirm({
      visible: isVisibleBlackListConfirm,
      title: '',
      content: `Would you like to ${
        blacklisted ? 'remove' : 'add'
      } ${domainName} ${blacklisted ? 'from' : 'to'} the blacklist?`,
      keyboard: false,
      maskClosable: false,
      okText: 'Yes',
      cancelText: 'No',
      onOk: () => this.handleAgreeBlackList(id),
      onCancel: () => this.handleCancelBlackList()
    });
  };

  handleAgreeBlackList = (id) => {
    const { blackList, domainData, removeFromBlackList, setDomainToBlackList } =
      this.props;
    const domainName = domainData && domainData.domain;
    const { blacklisted } = !_.isEmpty(domainData) && domainData;
    const actualFunction = blacklisted
      ? removeFromBlackList(id)
      : setDomainToBlackList(id);

    Promise.resolve(actualFunction)
      .then(() => {
        const error = blackList.hasError;

        if (!_.isEmpty(error)) {
          message.error(
            `We cannot confirm that ${domainName} is added to the blacklist. Please try again or report to the system administrator`
          );
        } else {
          message.success(
            `${domainName} is successfully ${
              blacklisted ? 'removed from' : 'added to'
            } the blacklist`
          );
        }
      })
      .then(() => this.getDomainData());
    // .then(() => {
    //   this.props.getDomainsImagesStatusesIds(this.props.domainForReviewData[0], {
    //     key: 'id',
    //     order: 'asc',
    //   });
    // })
    // .then(() => {
    //   this.startLoadData(id);
    // });
  };

  handleCancelBlackList = () => {
    this.setState(
      {
        isVisibleBlackListConfirm: false
      },
      () => {
        Modal.destroyAll();
      }
    );
  };

  saveCurrentChangesFromDomain = (
    id,
    countries = null,
    domains = null,
    notNeedUpdate = false
  ) => {
    const {
      saveCurrentChangesForDomain,
      domainData,
      form,
      saveCurrentChangesForImages,
      clearDomainReviewImagesData
    } = this.props;

    const { legalCaseClick, copyDomainData, workIndexes } = this.state;

    const notPursuable = copyDomainData && copyDomainData.notPursuable;
    // const error = saveChanges.hasError;
    const dataFromFields = form.getFieldsValue();
    const copyCurrentDomainData = _.cloneDeep(domainData);
    const updateDomainData = _.merge({}, copyCurrentDomainData, dataFromFields);
    updateDomainData.notPursuable = notPursuable;
    let newImagesInfo = [];

    if (countries) {
      dataFromFields.priorityCountry = countries?.priorityCountry || null;
      dataFromFields.otherCountries = countries?.otherCountries || null;
      updateDomainData.priorityCountry = countries?.priorityCountry || null;
      updateDomainData.otherCountries = countries?.otherCountries || null;
    }

    if (domains) {
      dataFromFields.website_radio = domains || null;
      updateDomainData.website_radio = domains || null;
    }

    if (dataFromFields.otherCountries === undefined) {
      updateDomainData.otherCountries = null;
    } else if (dataFromFields.priorityCountry === undefined) {
      updateDomainData.priorityCountry = null;
    }

    if (
      dataFromFields.priorityCountry === undefined &&
      dataFromFields.otherCountries === undefined
    ) {
      message.error('Country required!');
      return Promise.resolve(false);
    }

    if (workIndexes && !_.isEmpty(this.props.domainReviewImagesData)) {
      workIndexes.map((workIdx) => {
        let images =
          this.props.domainReviewImagesData &&
          this.props.domainReviewImagesData[`img_data_${workIdx}`];
        let updateImageObject = {
          id: images && images.imageData.id,
          status: images && images.imageData.status,
          delivered: images && images.imageData.delivered
        };
        return newImagesInfo.push(updateImageObject);
      });
    }

    if (!this.state.priorityLanguage) {
      updateDomainData.priorityLanguage = dataFromFields.priorityLanguage;
      this.setState({
        priorityLanguage: dataFromFields.priorityLanguage
      });
    }

    if (!this.state.notPriorityLanguage) {
      updateDomainData.otherLanguage = dataFromFields.otherLanguage;
      this.setState({
        notPriorityLanguage: dataFromFields.otherLanguage
      });
    }

    updateDomainData.isAccessible = !this.state.notAccessible;

    updateDomainData.priorityLanguage = this.state.priorityLanguage || null;
    updateDomainData.otherLanguage = this.state.notPriorityLanguage || null;

    // const currentImagesFromStorage =
    //   JSON.parse(localStorage.getItem("updateImagesDataStatus")) || [];
    // if (error) {
    //   message.success("Changes were not saved");
    //   return;
    // }

    // if (selectWebsiteAsNotCommercial && _.isEmpty(noCommercialReason)) {
    //   message.error('Non-commercial reason required!');
    //   return;
    // }

    // if (!_.isEmpty(photoColumnEditing)) {
    //   message.error('Complete the URL changes!');
    //   return;
    // }

    return Promise.resolve(saveCurrentChangesForDomain(id, updateDomainData))
      .then(() => {
        return saveCurrentChangesForImages(newImagesInfo, legalCaseClick).then(
          (result) => {
            this.setState({ confirmButtonIds: [] });
            return result;
          }
        );
      })
      .then(() => {
        message.success('Changes were saved successfully');
        localStorage.removeItem('updateImagesDataStatus');
        this.setState({
          currentChangesWereSaved: true,
          legalCaseClick: false
        });
      })
      .then(() => {
        if (!notNeedUpdate) {
          clearDomainReviewImagesData();
        }
      })
      .then(() => {
        if (!notNeedUpdate) this.getDomainData();
        return true;
      });
  };

  notPursuableChange = (e) => {
    const { copyDomainData } = this.state;
    this.setState({
      copyDomainData: {
        ...copyDomainData,
        notPursuable: e.target.checked
      },
      currentChangesWereSaved: false
    });
  };

  setNotPursuable = () => {
    const { copyDomainData } = this.state;
    const notPursuable = copyDomainData && copyDomainData.notPursuable;
    return (
      <Checkbox
        checked={notPursuable}
        onChange={(e) => this.notPursuableChange(e)}
      >
        NOT PURSUABLE
      </Checkbox>
    );
  };

  setArtShopStatus = (e) => {
    const { copyDomainData } = this.state;
    this.setState({
      copyDomainData: { ...copyDomainData, gallery: e.target.checked },
      currentChangesWereSaved: false
    });
  };

  onSelectChange = (selectedRowKeys, row) => {
    this.setState({
      selectedImagesIds: row,
      selectedRowKeys
    });
  };

  handleApproveDomain = (id) => {
    const { currentChangesWereSaved, photoColumnEditing } = this.state;
    const { approveCurrentDomain, domainData } = this.props;

    if (!_.isEmpty(photoColumnEditing)) {
      message.error('Complete the URL changes!');
      return;
    }

    Promise.resolve(
      !currentChangesWereSaved && this.saveCurrentChangesFromDomain(id)
    ).then(() => approveCurrentDomain(domainData, id));

    if (currentChangesWereSaved && approveCurrentDomain) {
      message.success('Approved successfully');
      this.changeDomain('next');
    } else {
      message.error('Approval failed');
    }
  };

  // onSelectChange = selectedRowKeys => {
  //   console.log('selectedRowKeys changed: ', selectedRowKeys);
  //   this.setState({ selectedRowKeys });
  // };

  render() {
    const {
      form,
      domainData,
      domainReviewImagesData,
      getCountriesListData = []
    } = this.props;
    const { getFieldDecorator } = form;
    const priorityCountries = getCountriesListData.filter(
      (country) => country.priority
    );
    const otherCountries = getCountriesListData.filter(
      (country) => !country.priority
    );
    const {
      activePageChangeModal,
      workIndexes,
      randomId,
      selectedRowKeys,
      valueForPriorityCountry
    } = this.state;

    const [checkPriorityCountry] = priorityCountries.filter((country) => {
      const value = valueForPriorityCountry || domainData.priorityCountry;
      return [country.alpha3Code, country.fullName, country.key, country.value]
        .filter(Boolean)
        .some(
          (countryValue) =>
            countryValue.toUpperCase() === (value || '').toUpperCase()
        );
    });
    const [checkOtherCountry] = otherCountries.filter(
      (country) =>
        country.key === (domainData.otherCountries || '').toUpperCase()
    );

    const rowSelection = {
      selectedRowKeys,
      getCheckboxProps: (record) => {
        const { id } = record;
        let deliveredId = [];

        _.forEach(workIndexes, (idx) => {
          const images = domainReviewImagesData[`img_data_${idx}`];
          const delivered = images && images.imageData.delivered;
          const imagesId = images && images.imageData.id;

          delivered && deliveredId.push(imagesId);
        });

        return {
          disabled: _.includes(deliveredId, id)
        };
      },
      onChange: this.onSelectChange
    };

    // const [checkPriorityLanguage] = this.props.languagesData && this.props.languagesData.filter((item) => {
    //    const language = valueForPriorityLanguage
    //      ? valueForPriorityLanguage
    //      : domainData.priorityLanguage && domainData.priorityLanguage;

    //    return item.key === language;
    //  });

    // const [checkOtherLanguage] = this.props.languagesData && this.props.languagesData.filter((item) => {
    //   const language = valueForPriorityLanguage
    //     ? valueForPriorityLanguage
    //     : domainData.otherLanguage && domainData.otherLanguage;

    //   return item.key === language;
    // });

    return (
      <Spin
        className='spinner-block'
        size='large'
        spinning={this.getSpinStatus()}
      >
        <ChangePageModal
          visible={activePageChangeModal}
          handleOk={this.handleModalOk}
          handleCancel={this.handleModalCancel}
        />
        <div className='QualityControl'>
          <div className='qc-header-content'>
            <div className='qc-domain-row'>
              {!_.isEmpty(domainData) ? (
                <div className='domain-copy'>
                  <h1>
                    <a
                      className='domain-name'
                      target='_blank'
                      rel='nofollow noopener noreferrer'
                      href={`//${domainData.domain}`}
                    >
                      {domainData.domain}
                    </a>
                  </h1>
                  <div className='domain-actions'>
                    <Button
                      onClick={this.handleCopy(domainData.domain)}
                      className='copy-button'
                      aria-label='Copy domain to clipboard'
                      title='Copy to clipboard'
                    >
                      <Icon type='copy' />
                    </Button>
                    <Button
                      type={this.state.notAccessible ? 'primary' : 'default'}
                      onClick={this.toggleDomainAccessibilityAndGetNext}
                    >
                      Mark as{' '}
                      {this.state.notAccessible
                        ? 'accessible'
                        : 'not accessible'}{' '}
                      and get next
                    </Button>
                  </div>
                </div>
              ) : (
                ''
              )}
            </div>
            <div className='qc-country-row'>
              <span className='qc-country-label'>Country:</span>
              <Form.Item className='qc-country-item'>
                {getFieldDecorator('priorityCountry', {
                  initialValue: checkPriorityCountry
                    ? checkPriorityCountry.alpha3Code
                    : undefined
                })(
                  <Select
                    className='priority-countries-list qc-country-select'
                    showSearch
                    placeholder='Priority'
                    optionFilterProp='children'
                    allowClear
                    onChange={(value) => {
                      this.changePriorityCountry(value, 'priorityCountry');
                      if (value) {
                        this.saveCurrentChangesFromDomain(
                          domainData.id,
                          { priorityCountry: value },
                          null,
                          true
                        );
                      } else {
                        this.changePriorityCountry(value, '');
                        this.saveCurrentChangesFromDomain(
                          domainData.id,
                          { otherCountries: value },
                          null,
                          true
                        );
                      }
                    }}
                    disabled={Boolean(checkOtherCountry && valueForPriorityCountry)}
                  >
                    {priorityCountries.map((country) => (
                      <Option value={country.alpha3Code} key={country.alpha3Code}>
                        {country.fullName}
                      </Option>
                    ))}
                  </Select>
                )}
              </Form.Item>
              <Form.Item className='qc-country-item'>
                {getFieldDecorator('otherCountries', {
                  initialValue: checkOtherCountry
                    ? checkOtherCountry.value
                    : undefined
                })(
                  <Select
                    className='other-countries-list qc-country-select'
                    showSearch
                    placeholder='Other'
                    optionFilterProp='children'
                    allowClear
                    onChange={(value) =>
                      this.changePriorityCountry(value, 'otherCountries')
                    }
                    disabled={Boolean(checkPriorityCountry && valueForPriorityCountry)}
                  >
                    {otherCountries.map((country) => (
                      <Option value={country.alpha3Code} key={country.alpha3Code}>
                        {country.fullName}
                      </Option>
                    ))}
                  </Select>
                )}
              </Form.Item>
            </div>
            <div className='qc-action-row'>
              <Button onClick={() => this.changeStep('prev')}>
                <Icon type='left' /> Back
              </Button>
              <Button onClick={() => this.saveAndGetNext(false)}>
                Save and get next <Icon type='right' />
              </Button>
              <Button type='primary' onClick={() => this.saveAndGetNext(true)}>
                Save, create draft and get next <Icon type='right' />
              </Button>
            </div>
          </div>
          <Row className='qc-filter-row'>
            <div className='ant-col-xs-24'>
              <div className='qc-filter-controls'>
                <Checkbox
                  // checked={}
                  onChange={this.handleFilterWithoutImageUrl}
                >
                  Without Image Url
                </Checkbox>
                <Select
                  style={{ width: 200 }}
                  placeholder='Choose'
                  onChange={this.handleChangeFilter}
                >
                  {_.map(Object.keys(FILTER_OPTIONS), (filterKey) => {
                    return [
                      <Option
                        key={`${FILTER_OPTIONS[filterKey].key}_asc`}
                        value={`${FILTER_OPTIONS[filterKey].key}_asc`}
                      >
                        <div
                          style={{
                            display: 'flex',
                            alignItems: 'center'
                          }}
                        >
                          {FILTER_OPTIONS[filterKey].name}
                          <Icon
                            type='caret-up'
                            style={{
                              marginLeft: 8
                            }}
                          />
                        </div>
                      </Option>,
                      <Option
                        key={`${FILTER_OPTIONS[filterKey].key}_desc`}
                        value={`${FILTER_OPTIONS[filterKey].key}_desc`}
                      >
                        <div
                          style={{
                            display: 'flex',
                            alignItems: 'center'
                          }}
                        >
                          {FILTER_OPTIONS[filterKey].name}
                          <Icon
                            type='caret-down'
                            style={{
                              marginLeft: 8
                            }}
                          />
                        </div>
                      </Option>
                    ];
                  })}
                </Select>
              </div>
            </div>
          </Row>
          <Row className='m-b-25'>
            <div className='ant-col-xs-24'>
              <div className='ant-col-xs-24'>
                <Pagination
                  hideOnSinglePage
                  showQuickJumper
                  defaultPageSize={this.state.pageSize}
                  // showTotal={this.showTotal}
                  current={this.state.pageNumber}
                  pageSize={this.state.pageSize}
                  className='mt-4 mb-4 mr-3'
                  total={this.props.domainImagesStatusesIdsData.length}
                  onChange={this.handleChangePage}
                />
              </div>
              <div className='ant-col-xs-24 m-b-25'>
                <Table
                  rowKey='id'
                  key={randomId}
                  filtered={true}
                  bordered
                  locale={{
                    emptyText: 'No data for the selected filters'
                  }}
                  columns={SIGHTINGS_COLUMNS}
                  pagination={false}
                  dataSource={this.prepareTableData()}
                  rowClassName={(record) => {
                    if (
                      !record.photographerName.props.photographerName.imageUrl
                    )
                      return `scroll_${record.id} red-color`;
                    return `scroll_${record.id}`;
                  }}
                  rowSelection={rowSelection}
                />
              </div>
              <div className='ant-col-xs-24'>
                <Pagination
                  hideOnSinglePage
                  showQuickJumper
                  defaultPageSize={this.state.pageSize}
                  // showTotal={this.showTotal}
                  current={this.state.pageNumber}
                  pageSize={this.state.pageSize}
                  className='mt-4 mb-4 mr-3'
                  total={this.props.domainImagesStatusesIdsData.length}
                  onChange={this.handleChangePage}
                />
              </div>
            </div>
          </Row>
          <div className='qc-action-row qc-bottom-action-row'>
            <Button onClick={() => this.changeStep('prev')}>
              <Icon type='left' /> Back
            </Button>
            <Button onClick={() => this.saveAndGetNext(false)}>
              Save and get next <Icon type='right' />
            </Button>
            <Button type='primary' onClick={() => this.saveAndGetNext(true)}>
              Save, create draft and get next <Icon type='right' />
            </Button>
          </div>
          <Row>
            <Col xs={24} md={4} style={{ textAlign: 'right' }}>
              <button
                onClick={() =>
                  jump('.target', {
                    duration: 1000,
                    offset: -10
                  })
                }
              >
                <Icon style={{ fontSize: '32px' }} type='up-circle' />
              </button>
            </Col>
          </Row>
        </div>
      </Spin>
    );
  }
}

function mapStateToProps({
  auth,
  userStore,
  commonStore,
  qc_frStore,
  exportFile,
  blackList,
  saveChanges,
  exportStore,
  searchStore
}) {
  return {
    userInfo: auth.userInfo,
    domainDataIsFetching: commonStore.domainDataIsFetching,
    domainData: commonStore.domainData,
    getNoCommercialReasonsData: commonStore.getNoCommercialReasonsData,
    imageDataIsFetching: commonStore.imageDataIsFetching,
    imageData: commonStore.imageData,
    languagesDataIsFetching: commonStore.languagesDataIsFetching,
    languagesData: commonStore.languagesData,
    loggedUserStatisticData: userStore.loggedUserStatisticData,
    facebookImageIsFetching: commonStore.facebookImageIsFetching,
    facebookImageUrl: commonStore.facebookImageUrl,
    facebookImageUrlError: commonStore.facebookImageUrlError,

    domainReserveData: qc_frStore.domainReserveData,
    domainImagesStatusesIdsData: qc_frStore.domainImagesStatusesIdsData,
    domainDeliveredIdsData: qc_frStore.domainDeliveredIdsData,
    lastDomainSightingsData: qc_frStore.lastDomainSightingsData,
    firstDomainSightingsData: qc_frStore.firstDomainSightingsData,
    domainForReviewData: qc_frStore.domainForReviewData,
    domainReviewImagesData: qc_frStore.domainReviewImagesData,
    downloadedImageData: qc_frStore.downloadedImageData,
    downloadedImageHeaderData: qc_frStore.downloadedImageHeaderData,
    addToDeliveredData: qc_frStore.addToDeliveredData,
    updateDomainAsReviewData: qc_frStore.updateDomainAsReviewData,
    domainHoldData: qc_frStore.domainHoldData,
    downloadedImageDataErrorMessage: qc_frStore.downloadedImageDataErrorMessage,
    updateImageStatusErrorMessage: qc_frStore.updateImageStatusErrorMessage,
    updateImagesDataErrorMessage: qc_frStore.updateImagesDataErrorMessage,
    setReturnedForCommentTrueErrorMessage:
      qc_frStore.setReturnedForCommentTrueErrorMessage,
    setReturnedForReviewErrorMessage:
      qc_frStore.setReturnedForReviewErrorMessage,
    updateDomainAsReviewDataErrorMessage:
      qc_frStore.updateDomainAsReviewDataErrorMessage,
    domainHoldDataErrorMessage: qc_frStore.domainHoldDataErrorMessage,
    updateDomainHoldDataErrorMessage:
      qc_frStore.updateDomainHoldDataErrorMessage,
    domainDeliveredIdsDataIsFetching:
      qc_frStore.domainDeliveredIdsDataIsFetching,
    domainImagesStatusesIdsDataIsFetching:
      qc_frStore.domainImagesStatusesIdsDataIsFetching,
    domainReserveDataIsFetching: qc_frStore.domainReserveDataIsFetching,
    lastDomainSightingsDataIsFetching:
      qc_frStore.lastDomainSightingsDataIsFetching,
    firstDomainSightingsDataIsFetching:
      qc_frStore.firstDomainSightingsDataIsFetching,
    domainForReviewDataIsFetching: qc_frStore.domainForReviewDataIsFetching,
    downloadedImageDataIsFetching: qc_frStore.downloadedImageDataIsFetching,
    updateImagesDataIsFetching: qc_frStore.updateImagesDataIsFetching,
    setReturnedForCommentTrueIsFetching:
      qc_frStore.setReturnedForCommentTrueIsFetching,
    setReturnedForReviewIsFetching: qc_frStore.setReturnedForReviewIsFetching,
    updateDomainAsReviewDataIsFetching:
      qc_frStore.updateDomainAsReviewDataIsFetching,
    domainHoldDataIsFetching: qc_frStore.domainHoldDataIsFetching,
    updateDomainHoldDataIsFetching: qc_frStore.updateDomainHoldDataIsFetching,
    deleteDomainHoldDataIsFetching: qc_frStore.deleteDomainHoldDataIsFetching,
    allImagesData: qc_frStore.allImagesData,
    exportFile: exportFile,
    blackList: blackList,
    saveChanges: saveChanges,
    exportStore: exportStore,
    reportStatus: exportFile.reportStatus,
    getCountriesListData: searchStore.getCountriesListData
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getReserveDomainPending: bindActionCreators(
      getReserveDomainPending,
      dispatch
    ),
    getDomainsImagesStatusesIds: bindActionCreators(
      getDomainsImagesStatusesIds,
      dispatch
    ),
    getDomainData: bindActionCreators(getDomainData, dispatch),
    getLanguages: bindActionCreators(getLanguages, dispatch),
    getLastDomainSightings: bindActionCreators(
      getLastDomainSightings,
      dispatch
    ),
    getLoggedUserStatisticData: bindActionCreators(
      getLoggedUserStatisticData,
      dispatch
    ),
    getFirstDomainSightings: bindActionCreators(
      getFirstDomainSightings,
      dispatch
    ),
    getCountriesList: bindActionCreators(getCountriesList, dispatch),
    saveDomainDataAsReview: bindActionCreators(
      saveDomainDataAsReview,
      dispatch
    ),
    getReserveDomainPendingForReview: bindActionCreators(
      getReserveDomainPendingForReview,
      dispatch
    ),
    getImageData: bindActionCreators(getImageData, dispatch),
    getDownloadedImagesData: bindActionCreators(
      getDownloadedImagesData,
      dispatch
    ),
    changeDomainReviewImagesData: bindActionCreators(
      changeDomainReviewImagesData,
      dispatch
    ),
    getDomainsDeliveredIDs: bindActionCreators(
      getDomainsDeliveredIDs,
      dispatch
    ),
    updateImageStatus: bindActionCreators(updateImageStatus, dispatch),
    changeDeliveredData: bindActionCreators(changeDeliveredData, dispatch),
    clearDomainReviewImagesData: bindActionCreators(
      clearDomainReviewImagesData,
      dispatch
    ),
    updateImagesData: bindActionCreators(updateImagesData, dispatch),
    setReturnedForCommentTrue: bindActionCreators(
      setReturnedForCommentTrue,
      dispatch
    ),
    setReturnedForReview: bindActionCreators(setReturnedForReview, dispatch),
    changeDomainDataInRedux: bindActionCreators(
      changeDomainDataInRedux,
      dispatch
    ),
    clearDeliveredData: bindActionCreators(clearDeliveredData, dispatch),
    updateDomainHoldData: bindActionCreators(updateDomainHoldData, dispatch),
    setDownLoadFileRequest: bindActionCreators(
      setDownLoadFileRequest,
      dispatch
    ),
    setDomainToBlackList: bindActionCreators(setDomainToBlackList, dispatch),
    saveCurrentChangesForDomain: bindActionCreators(
      saveCurrentChangesForDomain,
      dispatch
    ),
    saveCurrentChangesForImages: bindActionCreators(
      saveCurrentChangesForImages,
      dispatch
    ),
    updateImagesHoldData: bindActionCreators(updateImagesHoldData, dispatch),
    sendReportForImages: bindActionCreators(sendReportForImages, dispatch),
    setDeliveredStatus: bindActionCreators(setDeliveredStatus, dispatch),
    setBulkChanges: bindActionCreators(setBulkChanges, dispatch),
    removeFromBlackList: bindActionCreators(removeFromBlackList, dispatch),
    approveCurrentDomain: bindActionCreators(approveCurrentDomain, dispatch),
    discardQC: bindActionCreators(discardQC, dispatch),
    sendUpdatedImageURL: bindActionCreators(sendUpdatedImageURL, dispatch),
    filterSightings: bindActionCreators(filterSightings, dispatch),
    getFacebookImageUrl: bindActionCreators(getFacebookImageUrl, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Form.create({ name: 'QualityControlPageForm' })(QualityControlPage));
